import { setAuthToken } from "../../utils";
import cookie from "react-cookies";

export const userService = {
    login,
    logout,
    switchToSubUser,
    switchToMain,
    getAll
};

function login(username, password) {
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password })
    };

    return fetch("Account/Login", requestOptions).then(response => {
        if (!response.ok) {
            return Promise.reject(response.statusText);
        }
        return response.json().then(data => {
            // login successful if there's a jwt token in the response
            if (data.Errors && data.Errors.length) {
                //TODO handle login error
                return Promise.reject(data.Errors[0]);
            }
            const token = response.headers.get("portaltoken");
            if (!token) {
                return Promise.reject("InvalidTokenPassed");
            }
            const { Status, PortalUserSettings, LDAPUserRights } = data.Data;
            if (Status === "OK") {
                cookie.save("AuthToken", token, { path: "/" });
                sessionStorage.removeItem("DisableAutoLogin");
                localStorage.setItem(
                    "PortalUserSettings",
                    JSON.stringify(PortalUserSettings)
                );
                if (LDAPUserRights) {
                    localStorage.setItem(
                        "LDAPUserRights",
                        JSON.stringify(LDAPUserRights)
                    );
                }
                if (PortalUserSettings.customerGlobalId) {
                    localStorage.setItem(
                        "SubUserSettings",
                        JSON.stringify(PortalUserSettings)
                    );
                }
                setAuthToken(token);
            }
            return { PortalUserSettings, LDAPUserRights };
        });
    });
}

function logout(history) {
    // remove user from local storage to log user out
    cookie.remove("AuthToken", { path: "/" });
    localStorage.removeItem("PortalUserSettings");
    localStorage.removeItem("SubUserSettings");
    localStorage.removeItem("MainUserToken");
    sessionStorage.setItem("DisableAutoLogin", "true");
    if (history) {
        window.open("#/login", "_self");
        window.location.reload(true);
    }
}

function switchToSubUser(subUser, subUserToken) {
    localStorage.setItem("SubUserSettings", JSON.stringify(subUser));
    localStorage.setItem("MainUserToken", cookie.load("AuthToken"));
    cookie.save("AuthToken", subUserToken, { path: "/" });
    setAuthToken(subUserToken);
}

function switchToMain() {
    var token = localStorage.getItem("MainUserToken");
    cookie.save("AuthToken", token, { path: "/" });
    setAuthToken(token);
    localStorage.removeItem("SubUserSettings");
    localStorage.removeItem("MainUserToken");
}

function getAll() {
    const requestOptions = {
        method: "GET"
    };
    return fetch("/users", requestOptions).then(handleResponse);
}

function handleResponse(response) {
    if (!response.ok) {
        return Promise.reject(response.statusText);
    }
    return response.json();
}